/** Cookie name for anonymous_id so server can send it to backend for is_liked (must match fcm-utils). */
export const ANONYMOUS_ID_COOKIE_NAME = 'vesselly_anonymous_id';

/**
 * Parse anonymous_id from Cookie header (server-side).
 */
export function getAnonymousIdFromCookie(cookieHeader: string | null): string | null {
  if (!cookieHeader) return null;
  const match = cookieHeader.match(new RegExp(`${ANONYMOUS_ID_COOKIE_NAME}=([^;]+)`));
  if (!match) return null;
  try {
    return decodeURIComponent(match[1].trim());
  } catch {
    return null;
  }
}
